import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { DialogActions } from './dialog.actions';
import { CustomDialogsService } from './dialogs.service';
import { InitDialogPayload } from './dialog.model';

@Injectable()
export class DialogEffects {
  openDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DialogActions.openDialog),
        tap((action) => {
          this.customDialogService.openDialog(
            action.payload as InitDialogPayload
          );
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private customDialogService: CustomDialogsService
  ) {}
}
